import { render, staticRenderFns } from "./directDistributionView.vue?vue&type=template&id=75e8a440&"
import script from "./directDistributionView.vue?vue&type=script&lang=js&"
export * from "./directDistributionView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports